<template>
  <div class="operation-solution">
    <!-- 头部介绍 -->
    <div 
      class="solution-header"
      :style="{
        backgroundImage: pageData.cover ? `url(${pageData.cover})` : '',
      }"
    >
      <div class="container">
        <h1>{{ pageData.name || '运行维护服务' }}</h1>
        <p class="subtitle">{{ pageData.desc }}</p>
      </div>
    </div>

    <!-- 服务介绍 -->
    <section class="service-intro">
      <div class="container">
        <h2 class="section-title animate-title">全方位一站式运维服务</h2>
        <div class="intro-content">
          <div class="intro-text">
            <p>湖南美音凭借多年的运维服务管理经验，结合ITIL、ITSS等IT服务管理标准，形成了独有的IT运维服务最佳实践，为客户提供全方位一站式的运维服务。</p>
          </div>
          <div class="service-flow">
            <div class="service-items">
              <div class="service-item">
                <el-icon><OfficeBuilding /></el-icon>
                <span>机房基础设施</span>
              </div>
              <div class="service-item">
                <el-icon><Connection /></el-icon>
                <span>服务器存储</span>
              </div>
              <div class="service-item">
                <el-icon><SetUp /></el-icon>
                <span>操作系统</span>
              </div>
              <div class="service-item">
                <el-icon><Platform /></el-icon>
                <span>虚拟化平台</span>
              </div>
              <div class="service-item">
                <el-icon><DataLine /></el-icon>
                <span>数据库</span>
              </div>
              <div class="service-item">
                <el-icon><Box /></el-icon>
                <span>容器云</span>
              </div>
              <div class="service-item">
                <el-icon><Cloudy /></el-icon>
                <span>云平台</span>
              </div>
              <div class="service-item">
                <el-icon><Operation /></el-icon>
                <span>应用系统</span>
              </div>
              <div class="service-item">
                <el-icon><Lock /></el-icon>
                <span>安全服务</span>
              </div>
              <div class="service-item">
                <el-icon><Monitor /></el-icon>
                <span>终端</span>
              </div>
              <div class="service-item">
                <el-icon><VideoCamera /></el-icon>
                <span>会议</span>
              </div>
              <div class="service-item">
                <el-icon><Connection /></el-icon>
                <span>网络</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ITIL服务管理 -->
    <section class="itil-service">
      <div class="container">
        <h2 class="section-title animate-title">基于ITSS/ITIL的服务管理</h2>
        <div class="itil-content">
          <div class="itil-text">
            <p>摒弃以技术为驱动的传统架构，确定以组织战略和业务需求为出发点，以管理流程为导向，通过对IT服务与组织业务的整合，建立一套对IT系统规划、研发、实施和运营进行有效管理的高质量IT服务管理方法，提高IT服务提供和IT服务支持的能力与水平。</p>
          </div>
          <div class="itil-features">
            <div class="feature-item">
              <div class="feature-icon">
                <el-icon><Aim /></el-icon>
              </div>
              <div class="feature-content">
                <h3>战略规划</h3>
                <p>以组织战略和业务需求为出发点</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <el-icon><SetUp /></el-icon>
              </div>
              <div class="feature-content">
                <h3>流程导向</h3>
                <p>标准化的服务管理流程体系</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <el-icon><Connection /></el-icon>
              </div>
              <div class="feature-content">
                <h3>业务整合</h3>
                <p>IT服务与组织业务深度融合</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <el-icon><Refresh /></el-icon>
              </div>
              <div class="feature-content">
                <h3>持续改进</h3>
                <p>服务能力持续提升与优化</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="service-advantages">
      <div class="container">
        <h2 class="section-title animate-title">服务优势</h2>
        <div class="advantages-grid">
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Tools /></el-icon>
            </div>
            <div class="content">
              <h3>组织规模化</h3>
              <p>专业IT运维团队，提供7*24小时不间断服务保障，快速响应客户需求</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><CircleCheck /></el-icon>
            </div>
            <div class="content">
              <h3>服务标准化</h3>
              <p>基于ITIL的标准化服务流程，确保服务质量的一致性和可控性</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Monitor /></el-icon>
            </div>
            <div class="content">
              <h3>技术专业化</h3>
              <p>丰富的项目经验和技术积累，专业的技术团队提供全方位解决方案</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Connection /></el-icon>
            </div>
            <div class="content">
              <h3>工具智能化</h3>
              <p>采用先进的运维工具和智能平台，提升运维效率和服务质量</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { columnGet2 } from "@/api/court";
import { 
  Monitor, 
  SetUp, 
  Connection, 
  Platform, 
  DataLine, 
  Box, 
  Cloudy,
  Lock,
  VideoCamera,
  Aim,
  Refresh,
  OfficeBuilding,
  Operation,
  Service,
  Management,
  Medal,
  Money,
  Check,
  CircleCheck,
  Tools,
  Computer,
  Cpu
} from '@element-plus/icons-vue'

const pageData = ref({})

// 获取页面数据
const getPageData = async () => {
  try {
    const response = await columnGet2({
      page: 1,
      limit: 10000,
      is_enable: true,
      parent: 9,
    });
    if (response.data.code === 2000) {
      // 根据当前页面名称匹配对应的数据
      const data = response.data.data.data.find(item => {
        // 根据路径匹配对应的数据
        return item.name.includes('运行维护服务') || item.name.toLowerCase().includes('operation')
      })
      if (data) {
        pageData.value = data
      }
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
  }
}

onMounted(() => {
  // 确保页面从顶部开始显示
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  getPageData()
})
</script>

<style lang="scss" scoped>
// 定义主题色变量
$primary-color: #2b5dff;
$primary-light: rgba(43, 93, 255, 0.1);
$border-color: #e2e8f0;

.operation-solution {
  padding-top: 30px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  section {
    padding: 80px 0;
  }

  // 头部样式
  .solution-header {
    background-size: cover;
    color: #fff;
    padding: 60px 0 40px;
    text-align: center;
    position: relative;
    overflow: hidden;
    // margin-bottom: 60px;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0.5;
    }

    .container {
      position: relative;
      z-index: 1;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    h1 {
      font-size: 36px;
      margin-bottom: 10px;
      position: relative;
      display: inline-block;
      opacity: 0;
      transform: translateY(20px);
      animation: fadeInUp 0.8s ease forwards;
    }

    .subtitle {
      font-size: 18px;
      opacity: 0;
      transform: translateY(20px);
      animation: fadeInUp 0.8s ease forwards 0.2s;
      margin: 20px auto 0;
    }
  }

  // 服务介绍样式
  .service-intro {
    background: #fff;

    .intro-content {
      max-width: 900px;
      margin: 0 auto;

      .intro-text {
        text-align: center;
        margin-bottom: 60px;
        max-width: 800px;
        margin: 0 auto 60px;
        
        p {
          font-size: 18px;
          line-height: 1.8;
          color: #333;
          font-weight: 400;
          position: relative;
          padding: 30px 40px;
          background: #f8f9fc;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

          &::before {
            content: '"';
            position: absolute;
            top: 0;
            left: 20px;
            font-size: 60px;
            color: #2b5dff;
            opacity: 0.2;
            line-height: 1;
          }

          &::after {
            content: '"';
            position: absolute;
            bottom: -20px;
            right: 20px;
            font-size: 60px;
            color: #2b5dff;
            opacity: 0.2;
            line-height: 1;
          }
        }
      }

      .service-flow {
        margin-top: 60px;
        padding: 40px;
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .service-items {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          gap: 24px;
          row-gap: 30px;

          .service-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 24px 16px;
            background: #f8f9fc;
            border-radius: 12px;
            transition: all 0.3s ease;
            cursor: pointer;

            &:hover {
              transform: translateY(-5px);
              background: #fff;
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

              .el-icon {
                color: #fff;
                background: #2b5dff;
                transform: scale(1.1);
              }
            }

            .el-icon {
              font-size: 28px;
              color: #2b5dff;
              width: 60px;
              height: 60px;
              background: rgba(43, 93, 255, 0.1);
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 16px;
              transition: all 0.3s ease;
            }

            span {
              font-size: 16px;
              color: #333;
              text-align: center;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  // ITIL服务管理样式
  .itil-service {
    background: #f8f9fc;

    .itil-content {
      max-width: 1000px;
      margin: 0 auto;

      .itil-text {
        text-align: center;
        margin-bottom: 60px;
        
        p {
          font-size: 18px;
          line-height: 1.8;
          color: #333;
          font-weight: 400;
          padding: 30px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          position: relative;
          border-left: 4px solid #2b5dff;
        }
      }

      .itil-features {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 30px;

        .feature-item {
          background: #fff;
          padding: 30px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          gap: 20px;
          transition: all 0.3s ease;
          
          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
            
            .feature-icon {
              background: #2b5dff;
              
              .el-icon {
                color: #fff;
              }
            }
          }

          .feature-icon {
            width: 60px;
            height: 60px;
            background: rgba(43, 93, 255, 0.1);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;

            .el-icon {
              font-size: 28px;
              color: #2b5dff;
              transition: all 0.3s ease;
            }
          }

          .feature-content {
            flex: 1;
            
            h3 {
              font-size: 20px;
              color: #333;
              margin-bottom: 8px;
            }

            p {
              color: #666;
              line-height: 1.5;
              margin: 0;
            }
          }
        }
      }
    }
  }

  // 服务优势样式
  .service-advantages {
    background: #fff;
    
    h2 {
      text-align: center;
      font-size: 32px;
      margin-bottom: 50px;
      color: #333;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: #2b5dff;
        border-radius: 2px;
      }
    }

    .advantages-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      
      .advantage-item {
        background: #fff;
        padding: 30px;
        border-radius: 12px;
        display: flex;
        align-items: flex-start;
        gap: 20px;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          
          .icon {
            background: #2b5dff;
            
            .el-icon {
              color: #fff;
              transform: scale(1.1);
            }
          }
        }

        .icon {
          flex-shrink: 0;
          width: 60px;
          height: 60px;
          background: rgba(43, 93, 255, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;

          .el-icon {
            font-size: 28px;
            color: #2b5dff;
            transition: all 0.3s ease;
          }
        }

        .content {
          flex: 1;
          
          h3 {
            font-size: 20px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            color: #666;
            line-height: 1.6;
            margin: 0;
            font-size: 15px;
          }
        }
      }
    }
  }

  // 为偶数板块添加背景色
  section:nth-child(even) {
    background-color: #f8f9fc;
  }

  // 为奇数板块添加背景色
  section:nth-child(odd) {
    background-color: #fff;
  }

  // 移除 service-value 原有的背景色
  .service-value {
    background: none;
  }

  // 修改标题通用样式
  .section-title {
    text-align: center;
    font-size: 36px;
    margin-bottom: 50px;
    color: #333;
    position: relative;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.8s ease forwards;
    
    // 移除上方横线
    &::before {
      display: none; // 移除上方横线
    }
    
    // 只保留下方横线
    &::after {
      content: '';
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px; // 改为 60px 与其他方案一致
      height: 3px;
      background: #2b5dff;
      border-radius: 2px;
      opacity: 0;
      transform: translateX(-50%) scaleX(0);
      animation: expandLine 0.8s ease forwards 0.3s;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes expandLine {
    from {
      opacity: 0;
      transform: translateX(-50%) scaleX(0);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) scaleX(1);
    }
  }

  // 修改标题延迟动画
  section {
    &:nth-child(2) .section-title {
      animation-delay: 0.2s;
      &::after { animation-delay: 0.5s; } // 只保留下方横线的动画
    }
    &:nth-child(3) .section-title {
      animation-delay: 0.4s;
      &::after { animation-delay: 0.7s; }
    }
    &:nth-child(4) .section-title {
      animation-delay: 0.6s;
      &::after { animation-delay: 0.9s; }
    }
  }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes counter-rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

// 响应式调整
@media (max-width: 992px) {
  .operation-solution {
    .itil-content {
      grid-template-columns: 1fr !important;
    }

    .advantages-grid {
      grid-template-columns: 1fr !important;
    }

    .service-flow {
      .service-items {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
  }
}

@media (max-width: 768px) {
  .operation-solution {
    padding-top: 60px;

    .solution-header {
      h1 {
        font-size: 28px;
      }
    }

    .service-intro {
      .intro-content {
        .intro-text {
          p {
            font-size: 16px;
            padding: 20px;
            
            &::before,
            &::after {
              font-size: 40px;
            }
          }
        }
      }
    }

    .itil-service {
      .itil-content {
        .itil-text {
          p {
            font-size: 16px;
            padding: 20px;
          }
        }
      }
    }

    .service-advantages {
      .advantages-grid {
        grid-template-columns: 1fr;
        
        .advantage-item {
          padding: 20px;
          
          .icon {
            width: 50px;
            height: 50px;
            
            .el-icon {
              font-size: 24px;
            }
          }
          
          .content {
            h3 {
              font-size: 18px;
            }
            
            p {
              font-size: 14px;
            }
          }
        }
      }
    }

    .service-flow {
      .service-items {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }
  }
}

@media (max-width: 480px) {
  .operation-solution {
    .service-flow {
      padding: 20px !important;
    }
    
    .service-items {
      gap: 16px !important;
      
      .service-item {
        padding: 16px !important;
        
        .el-icon {
          width: 50px !important;
          height: 50px !important;
          font-size: 24px !important;
        }
        
        span {
          font-size: 14px !important;
        }
      }
    }
  }
}

.page-header {
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: repeating-linear-gradient(
      45deg,
      rgba(255,255,255,0.1),
      rgba(255,255,255,0.1) 10px,
      transparent 10px,
      transparent 20px
    );
    opacity: 0.1;
  }
}
</style> 